/* Functions for GTM-tracking */

jQuery( function( $ ) {
	/* Adds consultation class on contact form for GTM to track if any of the selections is choosen in the items variable */
	function addConsultationId() {
		$( 'select' ).each( function() {
			const items = [ 'Consultation about product or solution', 'Tekninen tuki', 'Tilbudsforespørsel eller salgskonsultasjon', 'Försäljning och konsultation' ];

			if ( items.includes( $( this ).val() ) ) {
				$( '.form-container form' ).addClass( 'consultation' );
				return false;
			}

			$( '.form-container form' ).removeClass( 'consultation' );
		} );
	}

	$( '.page-template-contact-us input' ).on( 'change', function() {
		addConsultationId();
	} );
	$( '.page-template-contact-us select' ).on( 'change', function() {
		addConsultationId();
	} );
} );
